import React, { useCallback, useEffect, useState } from "react";
import Topbar from "../../shared/topbar/Topbar";
import { Button, Checkbox, Grid, Paper } from "@mui/material";
import { firstFieldList, secondFieldList } from "../../../constants/fieldsList/FieldsList";
import { handleChangeHeader } from "../../../utils/commonFunctions/fieldCapitalize";
import { pink } from "@mui/material/colors";
import { api } from "../../../utils/api";
import { trackPromise } from "react-promise-tracker";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useNavigate } from "react-router-dom";
import ReplyIcon from "@mui/icons-material/Reply";

const Settings = () => {
	const user = localStorage.getItem("@user");
	const navigate = useNavigate();
	const [userDetails, setUserDetails] = useState<any>(null);
	const [key, setKey] = useState<string>("");
	const [groupOwnerSettings, setGroupOwnerSettings] = useState<any>(null);

	const getGroupOwnerSettingsDetails = useCallback(async () => {
		if (userDetails) {
			const settings = await trackPromise(api.settings.getGroupOwnerSettings(userDetails._id));
			setGroupOwnerSettings(settings);
		}
	}, [userDetails]);

	const handleEditGroupOwnerSettings = useCallback(
		async (key: string, checked: boolean) => {
			const editGroupOwnerSettingsPayload = {
				column_field: key,
				checked: checked
			};
			if (userDetails) {
				const response = await trackPromise(
					api.settings.updateGroupOwnerSettings(editGroupOwnerSettingsPayload, userDetails._id)
				);
				if (response) {
					alert("Group Owner Settings Updation Successful!");
					getGroupOwnerSettingsDetails();
				}
			}
		},
		[getGroupOwnerSettingsDetails, userDetails]
	);

	const handleUpdateSettings = async (key: string, checked: boolean) => {
		if (userDetails) {
			setGroupOwnerSettings(Object.assign({}, groupOwnerSettings, { [key]: checked }));
			handleEditGroupOwnerSettings(key, checked);
		}
	};

	const routeBack = () => {
		const path = "/idr/dashboard";
		navigate(path);
	};

	useEffect(() => {
		if (user) {
			setUserDetails(JSON.parse(user));
		}
	}, [user]);

	useEffect(() => {
		getGroupOwnerSettingsDetails();
	}, [getGroupOwnerSettingsDetails]);
	return (
		<div className="landing settings">
			<Topbar />
			<Button
				variant="contained"
				className="button-blue-light"
				style={{ marginTop: "3rem" }}
				onClick={() => routeBack()}
			>
				<ReplyIcon style={{ marginRight: "4px" }} />
				Return to Dashboard
			</Button>
			{groupOwnerSettings ? (
				<div className="fieldList">
					<Paper elevation={3} style={{ borderRadius: "15px", padding: "2rem" }}>
						<h2 style={{ color: "#ab455c", textAlign: "center", marginBottom: "4rem" }}>
							Grid Column Visibility
						</h2>
						<div className="fieldContainer">
							<Grid container>
								<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
									<Grid
										container
										style={{ marginBottom: "2rem", color: "#ab455c", fontWeight: "bold" }}
									>
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ fontWeight: "bold" }}>
											FIELD NAME
										</Grid>
										<Grid
											item
											xs={12}
											sm={12}
											md={6}
											lg={6}
											xl={6}
											style={{ display: "flex", justifyContent: "center" }}
										>
											View
										</Grid>
									</Grid>
									{firstFieldList.map((field, index) => {
										return (
											<Grid container key={0} style={{ marginBottom: "2rem" }}>
												<Grid
													item
													xs={12}
													sm={12}
													md={6}
													lg={6}
													xl={6}
													style={{ fontWeight: "bold" }}
												>
													{handleChangeHeader(field)}
												</Grid>
												<Grid
													item
													xs={12}
													sm={12}
													md={6}
													lg={6}
													xl={6}
													style={{ display: "flex", justifyContent: "center" }}
												>
													<Checkbox
														checked={groupOwnerSettings[field]}
														sx={{
															color: pink[800],
															"&.Mui-checked": {
																color: pink[600]
															}
														}}
														// eslint-disable-next-line prettier/prettier
														onChange={(event: any) =>
															handleUpdateSettings(field, event?.target.checked)
														}
													/>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
								<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
									<Grid
										container
										style={{ marginBottom: "2rem", color: "#ab455c", fontWeight: "bold" }}
									>
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ fontWeight: "bold" }}>
											FIELD NAME
										</Grid>
										<Grid
											item
											xs={12}
											sm={12}
											md={6}
											lg={6}
											xl={6}
											style={{ display: "flex", justifyContent: "center" }}
										>
											View
										</Grid>
									</Grid>
									{secondFieldList.map((field, index) => {
										return (
											<Grid container key={0} style={{ marginBottom: "2rem" }}>
												<Grid
													item
													xs={12}
													sm={12}
													md={6}
													lg={6}
													xl={6}
													style={{ fontWeight: "bold" }}
												>
													{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
												</Grid>
												<Grid
													item
													xs={12}
													sm={12}
													md={6}
													lg={6}
													xl={6}
													style={{ display: "flex", justifyContent: "center" }}
												>
													<Checkbox
														checked={groupOwnerSettings[field]}
														sx={{
															color: pink[800],
															"&.Mui-checked": {
																color: pink[600]
															}
														}}
														// eslint-disable-next-line arrow-parens
														onChange={(event) =>
															handleUpdateSettings(field, event?.target.checked)
														}
													/>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
							</Grid>
						</div>
						{/* <Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Group Number
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Claim #
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							First Name
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Last Name
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							DOS
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Date to Send Closure Ltr
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Closure Sent Date
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Total Charge
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Payee
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Discount
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Savings
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Allowable
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Co-Pay
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Nex Fees
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							Other Fees
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							View
						</Grid>
					</Grid> */}
					</Paper>
				</div>
			) : null}
		</div>
	);
};

export default Settings;
